let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k10Cs")).then(() => parcelRequire('6CeqQ'));